import React from 'react'
import { Modal } from '@enamelai/design-system'
import { Icon as AlertIcon } from '@enamelai/design-system/icons/Alert'

type CallFlowReassignNumberModalProps = {
  show: boolean
  phoneNumberLabel: string
  otherFlowName: string
  flowTypeLabel?: string
  onCancel: () => void
  onConfirm: () => void
}

const CallFlowReassignNumberModal: React.FC<
  CallFlowReassignNumberModalProps
> = ({
  show,
  phoneNumberLabel,
  otherFlowName,
  flowTypeLabel = 'call flow',
  onCancel,
  onConfirm,
}) => {
  const numberLabel = phoneNumberLabel.trim() || 'this number'
  const flowName = otherFlowName.trim() || 'another'
  const typeLabel = flowTypeLabel.trim() || 'call flow'

  return (
    <Modal
      open={show}
      onClose={onCancel}
      closeOnBackdrop={false}
      size="sm"
      variant="confirmation"
      title="Reassign number"
      icon={<AlertIcon width={16} height={16} aria-hidden="true" />}
      iconTone="warning"
      description={[
        `Are you sure you want to reassign ${numberLabel}?`,
        `This number is assigned to the ${flowName} ${typeLabel}. Reassigning it will remove it from that ${typeLabel} and add it here.`,
      ]}
      primaryLabel="Confirm"
      secondaryLabel="Cancel"
      onPrimaryClick={onConfirm}
      onSecondaryClick={onCancel}
    />
  )
}

export default CallFlowReassignNumberModal
